export default __webpack_public_path__ + "static/media/site.a4f464e3.svg";